import { Checkbox, Stack, Typography } from '@mui/material';
import React from 'react';
import 'src/components/styles/textfield.css';

interface TextFieldProps {
  placeholder?: string;
  label?: string;
  style?: React.CSSProperties;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  right?: React.ReactNode;
  helperText?: string;
  name: string;
  labelStyle?: React.CSSProperties;
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
  isCheckBox?: boolean;
  checked?: boolean;
  onChangeCheckBox?: (val: boolean) => void;
}

export const TextField: React.FC<TextFieldProps> = ({
  placeholder,
  label,
  style,
  value,
  onChange,
  type = 'text',
  right,
  helperText,
  name,
  labelStyle,
  disabled = false,
  error = false,
  fullWidth = false,
  isCheckBox = false,
  checked = false,
  onChangeCheckBox = () => {},
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: fullWidth ? '100%' : undefined,
      }}
    >
      {label && (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <label className="_input_label" style={{ ...labelStyle }}>
            {label}
          </label>
          {isCheckBox && (
            <Stack direction="row" alignItems="center" gap={1}>
              <label className="_input_label" style={{ ...labelStyle }}>
                Static
              </label>
              <Checkbox
                size="small"
                sx={{ m: 0, p: 0 }}
                checked={checked}
                onChange={() => onChangeCheckBox(!checked)}
              />
            </Stack>
          )}
        </Stack>
      )}
      <input
        disabled={disabled}
        type={type}
        placeholder={placeholder ?? ''}
        className={`_custom_input ${error ? '_input_error' : ''}`}
        style={{ ...style }}
        value={value}
        name={name}
        onChange={onChange}
      />
      {helperText && (
        <Typography variant="body2" color={error ? 'error' : 'textSecondary'} style={{ marginTop: 5 }}>
          {helperText}
        </Typography>
      )}
      {right && (
        <div className="_right_icon" style={{ bottom: helperText ? '37px' : '10px' }}>
          {right}
        </div>
      )}
    </div>
  );
};
